import { Flex, Text, SegmentedControl } from "@radix-ui/themes";
import { IntegerInput } from "@/components/integer-input";
import { FILTER_OPTIONS, FilterOption, FilterOptionLabels } from "../lib/const";

interface FilterParameterProps {
  label: string;
  options: FilterOptionLabels;
  value: FilterOption;
  numericValue?: number | undefined;
  minValue?: number;
  placeholder?: string;
  disabled?: boolean;
  hasInput?: boolean;
  onOptionChange: (value: FilterOption) => void;
  onNumericChange?: (value: number | undefined) => void;
}

export function FilterParameter({
  label,
  options,
  value,
  numericValue,
  minValue = 1,
  placeholder = `Min: ${minValue}`,
  disabled = false,
  hasInput = false,
  onOptionChange,
  onNumericChange,
}: FilterParameterProps) {
  const showInput = value === FILTER_OPTIONS.RANGE;

  return (
    <>
      <Text size="2" weight="bold" className="mb-2">
        {label}
      </Text>
      <Flex className="mb-4">
        <SegmentedControl.Root
          size="2"
          value={value}
          onValueChange={onOptionChange}
        >
          <SegmentedControl.Item value={FILTER_OPTIONS.ALL}>
            {options.all}
          </SegmentedControl.Item>
          <SegmentedControl.Item value={FILTER_OPTIONS.ZERO}>
            {options.zero}
          </SegmentedControl.Item>
          {FILTER_OPTIONS.ANY in options && options.any && (
            <SegmentedControl.Item value={FILTER_OPTIONS.ANY}>
              {options.any}
            </SegmentedControl.Item>
          )}
          <SegmentedControl.Item value={FILTER_OPTIONS.RANGE}>
            {options.range}
          </SegmentedControl.Item>
        </SegmentedControl.Root>
        {hasInput && (
          <IntegerInput
            min={minValue}
            placeholder={placeholder}
            allowNegative={false}
            className="ml-2"
            disabled={disabled || !showInput}
            value={showInput ? numericValue : undefined}
            onChange={onNumericChange}
          />
        )}
      </Flex>
    </>
  );
}
